module.exports = __webpack_public_path__ + "img/zeigling10.c64e0149.jpg";